import axios from "axios";

// Staff. Each write returns the response envelope and rejects with the axios
// response on error (the global interceptor already toasts it).
export default {

    namespaced: true,

    state: {

        employees: [],
        employee: {}

    },

    getters: {

        employees(state) {
            return state.employees;
        },
        employee(state) {
            return state.employee;
        }

    },

    mutations: {

        SET_EMPLOYEES(state, employees) {
            return state.employees = employees
        },

        SET_EMPLOYEE(state, employee) {
            return state.employee = employee
        }

    },

    actions: {

        async fetchEmployees({ commit }, params) {

            await axios.get('/api/v1/employees', { params: params })
                .then(res => {
                    commit('SET_EMPLOYEES', res.data);
                }).catch(err => {
                    return Promise.reject(err);
                })

        },

        async fetchEmployee({ commit }, employee_id) {

            await axios.get(`/api/v1/employees/${employee_id}`)
                .then(res => {
                    commit('SET_EMPLOYEE', res.data.data);
                }).catch(err => {
                    return Promise.reject(err);
                })

        },

        // POST /employees: the staff member and their login
        async createEmployee(_context, employee) {
            return await axios
                .post('/api/v1/employees', employee)
                .then((res) => res.data)
                .catch((err) => Promise.reject(err));
        },

        // PATCH /employees/{id}: the staff fields (company, login and status are fixed here)
        async updateEmployee(_context, employee) {
            return await axios
                .patch(`/api/v1/employees/${employee.employee_id}`, employee)
                .then((res) => res.data)
                .catch((err) => Promise.reject(err));
        },

        // the staff member's complete role list: roles = [{ name }]
        async assignEmployeeRole(_context, { employee_id, roles }) {
            return await axios
                .post(`/api/v1/employees/${employee_id}/assignRole`, { roles })
                .then((res) => res.data)
                .catch((err) => Promise.reject(err));
        },

        async changeEmployeePassword(_context, { employee_id, password, password_confirmation, change_password_next_login }) {
            return await axios
                .post(`/api/v1/employees/${employee_id}/password`, { password, password_confirmation, change_password_next_login })
                .then((res) => res.data)
                .catch((err) => Promise.reject(err));
        },

        // action: "enable" | "disable"; disabling signs the person out at once
        async setEmployeeStatus(_context, { employee_id, action, reason }) {
            return await axios
                .patch(`/api/v1/employees/${employee_id}/status`, { action, reason })
                .then((res) => res.data)
                .catch((err) => Promise.reject(err));
        },

    }

}
